import { IGeoPolygon } from "../models/IGeoPoint";
import * as turf from "@turf/turf";

export const getCentroid = (geoJson: object) => {
  const polygon = turf.polygon((geoJson as IGeoPolygon).coordinates);
  return turf.centroid(polygon);
};
